module.exports = __webpack_public_path__ + "img/merge.d94c22aa.svg";